module.exports = __webpack_public_path__ + "img/photo2_6.6fe0f5af.jpg";